import Vue from 'vue'
import App from './App.vue'
import Routes from './routes'
import VueRouter from 'vue-router'
import store from '../store'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGeolocation from 'vue-browser-geolocation';
import Toasted from 'vue-toasted';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Import global components
import sms from './components/reusuable/sms'
import changeFlag from './components/reusuable/changeFlag'
import calculator from './components/reusuable/paymentCalculator'
import paymentRetieval from './components/rental/customer/payment/retrieval/create'
import sendPaymentLink from './components/reusuable/sendPaymentLink'
import customerDetails from './components/reusuable/customerDetails'
import exportToCsv from './components/reusuable/exportToCsv'
import callKnowlarity from './components/reusuable/callKnowlarity'

// Register components
Vue.component('sms',sms )
Vue.component('changeFlag',changeFlag )
Vue.component('calculator',calculator )
Vue.component('paymentRetieval',paymentRetieval )
Vue.component('sendPaymentLink',sendPaymentLink )
Vue.component('customerDetails',customerDetails )
Vue.component('exportToCsv',exportToCsv )
Vue.component('call-knowlarity',callKnowlarity )

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
 
Vue.use(Toasted)
Vue.use(VueGeolocation); 
Vue.use(VueGoogleMaps,{
  load:{
    key:'AIzaSyC-eQsx6q7hHySLEqtnyKqUv1lTmB5pYLw' 
  },
  installComponents: false
})
Vue.component('GmapMap', VueGoogleMaps.Map);
Vue.component('GmapMarker', VueGoogleMaps.Marker);

Vue.toasted.register('my_app_error', 'Oops.. Something Went Wrong..', {
  type : 'error',
  icon : 'error_outline',
  duration: 2000
})
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(require('vue-moment'))

Vue.filter('currency', function (value) {
  return '₹' + parseFloat(value).toLocaleString();
});
Vue.filter('formatNumber', function (value) {
  return value > 999 && value < 99999 ? '₹' + ((value / 1000).toFixed(1)) + 'K' :
  value > 99999 && value < 9999999 ? '₹' + ((value / 100000).toFixed(1)) + 'L' :
  value > 9999999 && value < 99999999 ? '₹' + ((value / 10000000).toFixed(1)) + 'C' :
  '₹' + value
});
store.dispatch('switchUser', {
  online: 1
})
// store.dispatch('get_vehicle_count')
const router = new VueRouter({
  routes:Routes,
  mode: "history"
})
export const eventBus = new Vue();
new Vue({
  render: h => h(App),
  router:router,
  store
}).$mount('#app')
